(() => {
  'use strict';

  const container = document.getElementById('ProductGridContainer');
  const title = document.querySelector('title[data-daluca-title-base]');
  const canonical = document.querySelector('link[rel="canonical"]');
  if (!container || !title || !canonical || container.dataset.dalucaSchemaBound) return;
  container.dataset.dalucaSchemaBound = 'true';
  const titleDecoder = document.createElement('textarea');
  titleDecoder.innerHTML = title.dataset.dalucaTitleBase.replace(/</g, '&lt;');
  const titleBase = titleDecoder.value;
  const canonicalOrigin = new URL(canonical.href).origin;
  let scheduled = false;

  function update() {
    scheduled = false;
    const script = container.querySelector('[data-daluca-collection-schema]');
    if (!script) return;
    let schema;
    try { schema = JSON.parse(script.textContent); } catch (_) { return; }
    if (schema['@type'] !== 'CollectionPage' || !schema.mainEntity) return;

    const params = new URLSearchParams(location.search);
    const pageValue = params.get('page') || '1';
    const page = /^\d+$/.test(pageValue) ? Math.max(1, Number(pageValue)) : 1;
    const pageUrl = new URL(location.pathname, canonicalOrigin);
    if (page > 1) pageUrl.searchParams.set('page', String(page));
    const pageTitle = titleBase + (page > 1 ? ` – ${title.dataset.dalucaPageLabel} ${page}` : '') + title.dataset.dalucaTitleSuffix;
    if (document.title !== pageTitle) document.title = pageTitle;
    if (canonical.href !== pageUrl.href) canonical.href = pageUrl.href;
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl && ogUrl.content !== pageUrl.href) ogUrl.content = pageUrl.href;

    ['prev', 'next'].forEach(rel => {
      const link = container.querySelector(`.pagination-links a[rel="${rel}"]`);
      let headLink = document.head.querySelector(`link[rel="${rel}"]`);
      if (link) {
        if (!headLink) {
          headLink = document.createElement('link');
          headLink.rel = rel;
          document.head.append(headLink);
        }
        const destination = new URL(link.href);
        destination.searchParams.delete('preview_theme_id');
        destination.searchParams.delete('section_id');
        destination.searchParams.delete('sections');
        if (headLink.href !== destination.href) headLink.href = destination.href;
      } else if (headLink) {
        headLink.remove();
      }
    });

    const stockValues = params.getAll('filter.v.availability');
    const defaultStock = /\/collections\/two-piece-watch-straps\/?$/.test(location.pathname) &&
      stockValues.length === 1 && stockValues[0] === '1';
    const filtered = Array.from(params).some(([key, value]) => key.startsWith('filter.') && value.trim() !== '' &&
      !(defaultStock && key === 'filter.v.availability'));
    const sort = params.get('sort_by');
    const noindex = filtered || (sort && sort !== title.dataset.dalucaDefaultSort);
    let robots = document.querySelector('meta[data-daluca-collection-robots]');
    if (noindex && !robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex,follow';
      robots.setAttribute('data-daluca-collection-robots', '');
      document.head.append(robots);
    } else if (!noindex && robots) {
      robots.remove();
    }

    const priorItems = new Map((schema.mainEntity.itemListElement || []).map(item => [item.url, item]));
    const items = [];
    container.querySelectorAll('#product-grid > li').forEach(card => {
      if (!card.getClientRects().length) return;
      const link = card.querySelector('.product-card-title[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      const productPath = url.pathname.match(/\/products\/[^/]+\/?$/);
      if (url.origin !== location.origin || !productPath) return;
      const productUrl = new URL(productPath[0], canonicalOrigin).href;
      const item = {
        '@type': 'ListItem',
        position: items.length + 1,
        url: productUrl,
        name: link.getAttribute('title') || link.textContent.trim()
      };
      const image = card.querySelector('img');
      const imageUrl = priorItems.get(productUrl)?.image || image?.currentSrc || image?.src;
      if (imageUrl && /^https?:\/\//.test(imageUrl)) item.image = imageUrl;
      items.push(item);
    });
    schema['@id'] = `${pageUrl.href}#collection`;
    schema.url = pageUrl.href;
    if (schema.breadcrumb) schema.breadcrumb['@id'] = `${pageUrl.href}#breadcrumb`;
    schema.mainEntity.numberOfItems = items.length;
    schema.mainEntity.itemListElement = items;
    const json = JSON.stringify(schema);
    if (script.textContent !== json) script.textContent = json;

    const breadcrumb = document.querySelector('[data-daluca-breadcrumb-schema]');
    if (breadcrumb) {
      try {
        const data = JSON.parse(breadcrumb.textContent);
        if (data['@type'] === 'BreadcrumbList' && data['@id'] !== `${pageUrl.href}#breadcrumb`) {
          data['@id'] = `${pageUrl.href}#breadcrumb`;
          breadcrumb.textContent = JSON.stringify(data);
        }
      } catch (_) {}
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  new MutationObserver(mutations => {
    if (mutations.some(mutation => {
      const target = mutation.target;
      if (target.nodeType !== 1 || target.closest('script')) return false;
      return mutation.type === 'childList' || target.matches('#product-grid, #product-grid > li');
    })) schedule();
  }).observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'style', 'data-daluca-custom-fit-hidden']
  });
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  update();
})();

